<template>
	<el-dialog
			    title="创建卡片"
			    :visible.sync="dialogVisibe"
			    width="660px"
			    :custom-class="classNames + '_dialog'"
			    key="cardDialog"
				:close-on-press-escape="false"
				:close-on-click-modal="false"
			    @close="cardBtnCancel">
			        <div class="card-control-form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="150px">
						    <el-form-item label="卡片类型:" prop="card_type">
						        <el-radio-group v-model="ruleForm.card_type">
						            <el-radio  v-for="item in typeList" :label="item.value" :key="item.value" :disabled="ruleForm.id ? true : false">{{item.label}}</el-radio>
						        </el-radio-group>
						    </el-form-item>
							<el-form-item label="卡片标题:" prop="title">
							    <el-input v-model="ruleForm.title" placeholder="请输入卡片标题" maxlength="50" class="el-item-custom-w320" show-word-limit :disabled="ruleForm.cardFormInfoShow"></el-input>
							</el-form-item>
							<el-form-item label="卡片图片:" prop="media_id" v-if="ruleForm.card_type == 2 || ruleForm.card_type == 3">
							    <div :class="classNames+ '_upload-cont'">
									<div :class="classNames+ '_upload-left'">
										<!-- <el-upload
											class="media-uploader"
											:action="uploadUrl"
											:show-file-list="false"
											:headers="uploadHeaders"
											name="image"
											:on-success="onUploadSuccess"
											:accept="accept.join(',')"
											:before-upload="beforeMediaUpload">
											<img v-if="uploadImageSrc" :src="uploadImageSrc" class="media-uploader-show">
											<i v-else class="el-icon-plus media-uploader-icon"></i>
										</el-upload> -->
										
										<uploadFile v-model="ruleForm.image" @media_id="getMedia_id" @delete="deleteMedia_id" :item="{width: 263,height: 120,}" ></uploadFile>
										
									</div>
									<div :class="classNames+ '_upload-tips'">
										<p>1.建议尺寸263*120</p>
										<p>2.请上传小于5M的图片</p>
									</div>
									
									
								</div>
							</el-form-item>
							<el-form-item label="卡片内容:" prop="content">
							    <el-input  type="textarea" :rows="4" v-model="ruleForm.content" placeholder="请输入卡片内容" maxlength="100" class="el-item-custom-w320" show-word-limit :disabled="ruleForm.cardFormInfoShow"></el-input>
							</el-form-item>
							<el-form-item label="期望获取用户信息:" prop="components" v-if="ruleForm.card_type == 3">
								<el-checkbox-group v-model="ruleForm.components" :disabled="ruleForm.cardFormInfoShow">
								    <el-checkbox v-for="item in infoList" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item label="跳转按钮:"  v-if="ruleForm.card_type == 1">
							    <el-input v-model="ruleForm.button_name" placeholder="请输入卡片跳转按钮" maxlength="20" show-word-limit class="el-item-custom-w320"  :disabled="ruleForm.cardFormInfoShow"></el-input>
							</el-form-item>
							<el-form-item label="卡片跳转:" prop="status" v-if="ruleForm.card_type == 1 || ruleForm.card_type == 2">
							    <div :class="classNames+ '_mb20'">
							       <el-radio-group v-model="ruleForm.action_type">
							    	   <el-radio  v-for="item in actionTypeList" :label="item.value" :key="item.value" :disabled="ruleForm.cardFormInfoShow">{{item.label}}</el-radio>
							       </el-radio-group>
							    </div>
								<div :class="classNames+ '_mb20'" v-if="ruleForm.action_type == 4">
								   <el-select v-model="linkProduct_id" style="width: 200px; margin-right: 20px;" clearable @change="changeLinkProduct" :disabled="ruleForm.cardFormInfoShow">
								   	<el-option  label="请选择需要跳转的课程"
								   			:value="0" :key="-1"></el-option>
									<el-option v-for="(item, idx) in linkProductsList" :label="item.title + ' (' + item.price+'元)'"
								   		:value="item.id" :key="idx"></el-option>
								   </el-select>
								    <el-button type="primary" @click="makeLinkBtn()" v-show="linkProduct_id">生成链接</el-button>
								</div>
								<div :class="classNames+ '_mb20'">
							    	<el-input  type="textarea" :rows="4" v-model="ruleForm.jump_url" :disabled="ruleForm.action_type == 4 || ruleForm.cardFormInfoShow" placeholder="请输入卡片跳转链接/内容，若跳转为课程，需进入小程序对应课程详情页，复制课程链接" maxlength="100" show-word-limit class="el-item-custom-w320"></el-input>
							    </div>
								
							</el-form-item>
						<!-- 	<el-form-item label="电话拨打:" prop="phone" v-if="ruleForm.card_type == 4">
							    <el-input v-model="ruleForm.phone" type="tel" placeholder="请输入电话拨打的手机号" maxlength="11"></el-input>
							</el-form-item> -->
						 </el-form>
					</div>
			        <span slot="footer" class="dialog-footer">
			            <el-button @click="cardBtnCancel()">取 消</el-button>
			            <el-button type="primary" @click="cardBtnSure()">确 定</el-button>
			        </span>
			</el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { getBaseUrl } from '@/utils/baseUrl.js'
import uploadFile from './upload/uploadFile.vue'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
		cardFormInfo: {
		    type: Object,
			default: () => ({
				id: '',
				author_id:'',
				card_type: 4,
				open_card_id: '',
				title: '',
				image: '',
				content: '',
				media_id: '',
				components: [],
				action_type:'',
				jump_url: '',
				button_name: '',
				audit_status: 0,
				reject: '',
				status: '',
				card_status: ''
			})
		},
		accept: {
			type: Array,
			default: () => ['.jpg', '.png', '.jpeg', '.tif', '.jfif']
		}
	},
	data() {
		return {
			showFlag: true,
			apiBaseUrl: '',
            classNames: "cardDialog",
			uploadImageSrc: '',
			uploadUrl: '',
			rules: {
			    card_type: [
			        { required: true, message: '请选择卡片类型', trigger: 'change' }
			    ],
				title: [
				    { required: true, message: '请输入卡片标题', trigger: 'blur' },
				],
				content: [
				    { required: true, message: '请输入卡片内容', trigger: 'blur' },
				],
				components: [
				    { required: true, message: '请选择期望获取用户信息', trigger: 'change' },
				],
				media_id: [
				    { required: true, message: '请上传图片', trigger: 'change' },
				],
				phone: { required: true,  trigger: 'blur',
					 validator: (rule, value, callback) => {
					 	if(!value) {
					 		callback(new Error('请输入电话拨打的手机号'))
							
					 	} else {
							if(0 < value.length && value.length < 11) {
								callback(new Error('请输入正确的手机号'))
							} else{
								const reg_tel = /^1[3-9]\d{9}$/;
								 if (!reg_tel.test(value)) {
									callback(new Error('请输入正确的手机号'))
								 }
							}
						}
						callback()
					 },
			},
			},
			typeList: [
			    {
			        label: '留资卡片',
			        value: 3
			    },
			    {
			        label: '文字卡片',
			        value: 1
			    },
				{
				    label: '图片卡片',
				    value: 2
				},
				// {
				//     label: '电话拨打',
				//     value: 4
				// }
			],
			infoList:[
			    {
			        label: '姓名',
			        value: 1
			    },
			    {
			        label: '手机号',
			        value: 2
			    },
				{
				    label: '城市',
				    value: 3
				}
			],
			actionTypeList:[
			    // {
			    //     label: '外部跳转',
			    //     value: 2
			    // },
			    {
			        label: '跳转小程序',
			        value: 4
			    }
			],
			linkProductsList: [],
			linkProduct_id: 0
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		},
		ruleForm: {
			get() {
				return this.cardFormInfo
			},
			set(news) {
				// this.ruleForm = news
			}
		},
	},
	components: {
		uploadFile
	},
	created() {
		this.uploadUrl = getBaseUrl() + '/message/tool/client_upload'
		const token = localStorage.getItem('token') || ''
		
		this.uploadHeaders = {
			token: token
		}
		this.getProductsList()
	},
	methods: {
		...mapActions('dymessage', ['cardsAdd','cardUrlLink','productsList']),
		async httprequest(params) {
			params.limit = params.pageSize
			this.searchParams = params
			let res = await this.cardsAdd(params)
			return {total:res.count,data:res.data}
		},
		cardBtnSure(){
			if(this.ruleForm.cardFormInfoShow){
				this.resetFormInfo()
				return
			}
			this.$refs.ruleForm.validate(async (valid) => {
				if(valid) {
					try {
						const paramsData = Object.assign({},this.ruleForm)
						if(paramsData.card_type == 3 && paramsData.components.length){
							paramsData.components = paramsData.components.join(',')
						} else {
							paramsData.components = ''
						}
						await this.cardsAdd(paramsData)
						this.$emit('getCardList')
						this.resetFormInfo()
					} catch (error) {
						this.$message({
						    type: 'error',
						    message:'操作失败',
						    duration: 3000
						})
					}
				}
			})
		},
		cardBtnCancel(){
			this.dialogVisibe = false
		},
		resetFormInfo(){
			this.dialogVisibe = false
			this.uploadImageSrc = ''
			this.ruleForm.media_id = ''
			this.ruleForm.image = ''
		},
		async makeLinkBtn(){
			if(this.linkProduct_id){
				const res = await this.cardUrlLink({product_id: this.linkProduct_id})
				this.ruleForm.jump_url = res.url_link	
			} else {
				this.$message({
				    type: 'error',
				    message:'请先选择课程',
				    duration: 3000
				})
			}
		},
		changeLinkProduct(data) {
			console.log('dd',data)
			this.ruleForm.jump_url = ''
			if(!data) {
				this.linkProduct_id = 0
			}
		},
		async getProductsList(){
			try{
				const res = await this.productsList()
				if(res.length){
					this.linkProductsList = res
				} else {
					this.linkProductsList = []
				}
			}catch(e){
				this.linkProductsList = []
			}
			
		},
		getMedia_id(data){
			this.ruleForm.media_id = data
		},
		deleteMedia_id(data){
			this.ruleForm.media_id = ''
			this.ruleForm.image = ''
		},
		 onUploadSuccess(res, file) {
			 if(res && res.code == 0){
				this.ruleForm.media_id = res.data.media_id
				this.uploadImageSrc = URL.createObjectURL(file.raw);
			 }
			 
		  },
		  beforeMediaUpload(file) {
			const imageSize = file.size / 1024 / 1024 < 5;
			if (!imageSize) {
			  this.$message.error('上传图片大小不能超过5MB!');
			}
			return imageSize;
		  }
	}
}
</script>
<style lang="less">
    .cardDialog_dialog {
        .el-dialog__body {
            padding: 12px 20px;
        }
		.el-dialog__footer{
			text-align: center;
		}
		.el-item-custom-w320{
			width: 320px;
		}
    }
	
</style>
<style lang="less">
	 @classNames: cardDialog;
	.@{classNames}_upload-cont {
		display:flex;
		.@{classNames}_upload-left {
			width: 263px;
			height: 120px;
			margin-right:10px;
		}
		.@{classNames}_upload-tips {
			margin-right:10px;
		}
	}
	.@{classNames}_mb20{
		margin-bottom: 20px;
	}
	  .media-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .media-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .media-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 263px;
	    height: 120px;
	    line-height: 120px;
	    text-align: center;
	  }
	  .media-uploader-show {
	    width: 263px;
	    height: 120px;
	    display: block;
	  }
	</style>
